import type { WidgetEntity } from 'src/entities/widget/WidgetEntity';
import type { TSerializedWidget } from 'src/entities/workspace/types';
import { requireService } from 'src/packages/di';
import type { TWidgetMapperOptions } from 'src/serializers/WidgetSerializerService';

export function mapWidgets(widgets: TSerializedWidget[], options?: TWidgetMapperOptions): WidgetEntity[] {
  const mappedWidgets: WidgetEntity[] = [];

  widgets.forEach((widget, index) => {
    try {
      const mappedWidget = mapWidget(widget, index, options);

      mappedWidgets.push(mappedWidget);
    } catch (e) {
      console.error(`Widget of type "${widget.type}" is no available.`);
    }
  });

  return mappedWidgets;
}

export function mapWidget(widget: TSerializedWidget, index: number, options?: TWidgetMapperOptions): WidgetEntity {
  const mapWidgetService = requireService('widgetSerializer');

  return mapWidgetService.map(widget, index, options);
}
